export const CONSENT_KEY = 'corelabs_consent';
export const CONSENT_VERSION = '2026-08-01';
export const CONSENT_MAX_AGE_MS = 180 * 24 * 60 * 60 * 1000;

const LEGACY_CONSENT_KEY = 'cookie_consent';

export const readConsent = (now = Date.now()) => {
    try {
        localStorage.removeItem(LEGACY_CONSENT_KEY);
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return null;
        const value = JSON.parse(raw);
        const timestamp = Date.parse(value.timestamp);
        const categories = value.consent || {};
        if (
            value.version !== CONSENT_VERSION ||
            categories.necessary !== true ||
            ['functional', 'analytics', 'marketing'].some(key => typeof categories[key] !== 'boolean') ||
            !Number.isFinite(timestamp) ||
            timestamp > now + 5 * 60 * 1000 ||
            now - timestamp > CONSENT_MAX_AGE_MS
        ) {
            localStorage.removeItem(CONSENT_KEY);
            sessionStorage.removeItem('analytics_session');
            return null;
        }
        return value;
    } catch {
        localStorage.removeItem(CONSENT_KEY);
        sessionStorage.removeItem('analytics_session');
        return null;
    }
};

export const writeConsent = (consent, { consentId = '', timestamp = new Date().toISOString() } = {}) => {
    const value = {
        version: CONSENT_VERSION,
        timestamp,
        consent_id: consentId,
        consent: { functional: false, analytics: false, marketing: false, ...consent, necessary: true },
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
    localStorage.removeItem(LEGACY_CONSENT_KEY);
    if (!value.consent.analytics) sessionStorage.removeItem('analytics_session');
    return value;
};

export const analyticsConsent = () => {
    const value = readConsent();
    return value?.consent?.analytics && value.consent_id ? value : null;
};
